import { Routes } from '@angular/router';
import { SignupComponent } from './pages/signup/signup.component';

export const SIGNUP_ROUTES: Routes = [
    {
        path: 'signup',
        component: SignupComponent,
    },
];
